import React from 'react';
import { Row, Col, Form, Accordion } from 'react-bootstrap';
import '../../../scss/elements/forms.scss';

const MedicalQuestionnaire = ({ orderHistory, medicalData, medicalHistory, userData, chatUserProfile }) => {
    if (!medicalData || Object.keys(medicalData).length === 0) {
        return (
            <div className="container mt-4">
                <div className="alert alert-warning" role="alert">
                    This user has not completed a medical questionniare and cannot order NRT.
                </div>
            </div>
        );
    }

    return (
        <>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <Row className="w-100">
                            <Col>
                                <h5 className="mb-0">Medical Assessment</h5>
                            </Col>
                        </Row>
                    </Accordion.Header>
                    <Accordion.Body className="p-2 px-1">
                        <Row>
                            <Col className="p-0">
                                {medicalData ?
                                    (
                                        <Form>
                                            <div className="formGrouping">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Accepted T&Cs?</Form.Label>
                                                    <Form.Control type="text" name="acceptedTermsAndConditions" value={medicalData.acceptedTermsAndConditions ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                            </div>
                                            <div className="formGrouping">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Allergies?</Form.Label>
                                                    <Form.Control type="text" name="allergies" value={medicalData.allergies ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>

                                                {medicalData.allergies &&
                                                    (<Form.Group className="mb-3">
                                                        <Form.Label>Allergy info</Form.Label>
                                                        <Form.Control type="text" name="allergies_Info" value={medicalData.allergies_Info || ''} readOnly />
                                                    </Form.Group>)
                                                }
                                            </div>
                                            <div className="formGrouping">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Taking medication?</Form.Label>
                                                    <Form.Control type="text" name="areYouTakingAnyOfTheFollowing" value={medicalData.areYouTakingAnyOfTheFollowing ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                            </div>
                                            <div className="formGrouping">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Has any health conditions?</Form.Label>
                                                    <Form.Control type="text" name="hasAnyHealthConditions" value={medicalData.hasAnyHealthConditions ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>

                                                {medicalData.hasAnyHealthConditions &&
                                                    (<Form.Group className="mb-3">
                                                        <Form.Label>Health condition info</Form.Label>
                                                        <Form.Control type="text" name="hasAnyHealthConditions_Info" value={medicalData.hasAnyHealthConditions_Info || ''} readOnly />
                                                    </Form.Group>)
                                                }

                                                {medicalData.hasAnyHealthConditions &&
                                                    (<Form.Group className="mb-3">
                                                        <Form.Label>Name and dose info</Form.Label>
                                                        <Form.Control type="text" name="hasAnyHealthConditions_NameAndDoseOfAllMedications" value={medicalData.hasAnyHealthConditions_NameAndDoseOfAllMedications || ''} readOnly />
                                                    </Form.Group>)
                                                }
                                            </div>
                                            <div className="formGrouping">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Had adverse reactions to using nicotine in the past?</Form.Label>
                                                    <Form.Control type="text" name="haveHadAdverseReactionsUsingNicotineInPast" value={medicalData.haveHadAdverseReactionsUsingNicotineInPast ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>

                                                {medicalData.haveHadAdverseReactionsUsingNicotineInPast &&
                                                    (<Form.Group className="mb-3">
                                                        <Form.Label>Adverse reaction info</Form.Label>
                                                        <Form.Control type="text" name="haveHadAdverseReactionsUsingNicotineInPast_Info" value={medicalData.haveHadAdverseReactionsUsingNicotineInPast_Info || ''} readOnly />
                                                    </Form.Group>)
                                                }

                                            </div>

                                            <div className="formGrouping">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Had reactions to NRT?</Form.Label>
                                                    <Form.Control type="text" name="haveYouHadReactionToNRT" value={medicalData.haveYouHadReactionToNRT ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>

                                                {medicalData.haveYouHadReactionToNRT &&
                                                    (<Form.Group className="mb-3">
                                                        <Form.Label>NRT reaction info</Form.Label>
                                                        <Form.Control type="text" name="haveYouHadReactionToNRT_Info" value={medicalData.haveYouHadReactionToNRT_Info || ''} readOnly />
                                                    </Form.Group>)
                                                }
                                            </div>
                                            <div className="formGrouping">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Oxygen therapy?</Form.Label>
                                                    <Form.Control type="text" name="oxygenTherapy" value={medicalData.oxygenTherapy ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>

                                                {medicalData.oxygenTherapy &&
                                                    (<Form.Group className="mb-3">
                                                        <Form.Label>Oxygen therapy info</Form.Label>
                                                        <Form.Control type="text" name="oxygenTherapy_Info" value={medicalData.oxygenTherapy_Info || ''} readOnly />
                                                    </Form.Group>)
                                                }
                                            </div>
                                            <div className="formGrouping">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Currently pregnant?</Form.Label>
                                                    <Form.Control type="text" name="pregnant" value={medicalData.pregnant ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                            </div>

                                            <div className="formGrouping">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Recently finished medication?</Form.Label>
                                                    <Form.Control type="text" name="recentlyFinishedMedication" value={medicalData.recentlyFinishedMedication ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>

                                                {medicalData.recentlyFinishedMedication_Info &&
                                                    (<Form.Group className="mb-3">
                                                        <Form.Label>Recent medication info</Form.Label>
                                                        <Form.Control type="text" name="recentlyFinishedMedication_Info" value={medicalData.recentlyFinishedMedication_Info || ''} readOnly />
                                                    </Form.Group>)
                                                }
                                            </div>
                                        </Form>
                                    )
                                    :
                                    (
                                        <p className="text-center">No Medical Data Recorded</p>
                                    )
                                }
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>



            {medicalHistory && medicalHistory.length > 0 && (
                <Accordion className="mt-3">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <Row className="w-100">
                                <Col>
                                    <h5 className="mb-0">Medical Questionnaire History ({medicalHistory.length})</h5>
                                </Col>
                            </Row>
                        </Accordion.Header>
                        <Accordion.Body className="p-2 px-1">
                            <Row>
                                <Col className="p-0">
                                    <Accordion>
                                        {medicalHistory.map((submission, index) => (
                                            <Accordion.Item eventKey={String(index)} key={submission.id || index}>
                                                <Accordion.Header>
                                                    <Row className="w-100">
                                                        <Col>
                                                            Submission {index + 1}{index === 0 ? ' (latest)' : ''}
                                                            {submission.createdAt && (
                                                                <span className="text-muted ms-2">
                                                                    {new Date(submission.createdAt).toLocaleString()}
                                                                </span>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <Form>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Accepted T&Cs?</Form.Label>
                                                    <Form.Control type="text" value={submission.acceptedTermsAndConditions ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Currently pregnant?</Form.Label>
                                                    <Form.Control type="text" value={submission.pregnant ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Allergies?</Form.Label>
                                                    <Form.Control type="text" value={submission.allergies ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                                {submission.allergies && (
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Allergy info</Form.Label>
                                                        <Form.Control type="text" value={submission.allergies_Info || ''} readOnly />
                                                    </Form.Group>
                                                )}
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Taking medication?</Form.Label>
                                                    <Form.Control type="text" value={submission.areYouTakingAnyOfTheFollowing ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Has any health conditions?</Form.Label>
                                                    <Form.Control type="text" value={submission.hasAnyHealthConditions ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                                {submission.hasAnyHealthConditions && (
                                                    <>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Health condition info</Form.Label>
                                                            <Form.Control type="text" value={submission.hasAnyHealthConditions_Info || ''} readOnly />
                                                        </Form.Group>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Name and dose info</Form.Label>
                                                            <Form.Control type="text" value={submission.hasAnyHealthConditions_NameAndDoseOfAllMedications || ''} readOnly />
                                                        </Form.Group>
                                                    </>
                                                )}
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Had adverse reactions to using nicotine in the past?</Form.Label>
                                                    <Form.Control type="text" value={submission.haveHadAdverseReactionsUsingNicotineInPast ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                                {submission.haveHadAdverseReactionsUsingNicotineInPast && (
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Adverse reaction info</Form.Label>
                                                        <Form.Control type="text" value={submission.haveHadAdverseReactionsUsingNicotineInPast_Info || ''} readOnly />
                                                    </Form.Group>
                                                )}
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Had reactions to NRT?</Form.Label>
                                                    <Form.Control type="text" value={submission.haveYouHadReactionToNRT ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                                {submission.haveYouHadReactionToNRT && (
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>NRT reaction info</Form.Label>
                                                        <Form.Control type="text" value={submission.haveYouHadReactionToNRT_Info || ''} readOnly />
                                                    </Form.Group>
                                                )}
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Oxygen therapy?</Form.Label>
                                                    <Form.Control type="text" value={submission.oxygenTherapy ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                                {submission.oxygenTherapy && (
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Oxygen therapy info</Form.Label>
                                                        <Form.Control type="text" value={submission.oxygenTherapy_Info || ''} readOnly />
                                                    </Form.Group>
                                                )}
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Recently finished medication?</Form.Label>
                                                    <Form.Control type="text" value={submission.recentlyFinishedMedication ? 'Yes' : 'No'} readOnly />
                                                </Form.Group>
                                                {submission.recentlyFinishedMedication_Info && (
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Recent medication info</Form.Label>
                                                        <Form.Control type="text" value={submission.recentlyFinishedMedication_Info || ''} readOnly />
                                                    </Form.Group>
                                                )}
                                                    </Form>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            )}

            <Accordion className="mt-3">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <Row className="w-100">
                            <Col>
                                <h5 className="mb-0">Client Data</h5>
                            </Col>
                        </Row>
                    </Accordion.Header>
                    <Accordion.Body className="p-2 px-1">
                        <Row>
                            <Col className="p-0">
                                <Form>
                                    <h4 className="formGrouping">Client Information</h4>
                                    <div className="formGrouping">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Client ID</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clientId"
                                                value={chatUserProfile.id}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Client Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clientName"
                                                value={chatUserProfile.profile.firstName + " " + chatUserProfile.profile.familyName}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Client Email</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clientEmail"
                                                value={chatUserProfile.email}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Client DOB</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clientDOB"
                                                value={chatUserProfile.profile.dateOfBirth}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Client Postcode</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clientPostcode"
                                                value={chatUserProfile.profile.postcode}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Client Service Area</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clientServiceArea"
                                                value={chatUserProfile.profile.serviceArea?.name ?? "N/A"}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Client Address</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clientAddress"
                                                value={chatUserProfile.profile.address}
                                                readOnly
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Client Address Line 1</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clientAddressLine1"
                                                value={chatUserProfile.profile.addressLine1}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Client Address Line 2</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clientAddressLine2"
                                                value={chatUserProfile.profile.addressLine2}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Client Address Line 3</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="clientAddressLine3"
                                                value={chatUserProfile.profile.addressLine3}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </div>
                                    <h4 className="formGrouping">Client Question Data</h4>
                                    <div className="formGrouping">
                                        {userData && userData.length > 0 ? (
                                            userData.map((item, index) => (
                                                <Form.Group className="mb-3" key={index}>
                                                    <Form.Label>{item.questionText}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name={item.questionId}
                                                        value={item.selectedOptionText || item.answerText}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            ))
                                        ) : (
                                            <p className="text-center">No Question Data Available</p>
                                        )}
                                    </div>
                                </Form>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            {orderHistory && orderHistory.length > 0 ? (
                <Accordion className="mt-3">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <Row className="w-100">
                                <Col>
                                    <h5 className="mb-0">NRT Order History</h5>
                                </Col>
                            </Row>
                        </Accordion.Header>
                        <Accordion.Body className="p-2 px-1">
                            <Row>
                                <Col className="p-0">
                                    <Form>
                                        {orderHistory.map((order, index) => (
                                            <div key={index} className="mb-4 border-bottom pb-3">
                                                <h4 className="formGrouping">Order {index + 1}</h4>

                                                <Form.Group className="mb-3">
                                                    <Form.Label>Created By</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={order.createdByName}
                                                        readOnly
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label>Date Created</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={order.dateCreated}
                                                        readOnly
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label>Notes</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        value={order.notes || "N/A"}
                                                        readOnly
                                                    />
                                                </Form.Group>

                                                <h5 className="formGrouping">Products</h5>
                                                {order.products && order.products.length > 0 ? (
                                                    order.products.map((prod, pIndex) => (
                                                        <Form.Group className="mb-3" key={pIndex}>
                                                            <Form.Label>Product {pIndex + 1}</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={prod.product?.name || "Unnamed Product"}
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    ))
                                                ) : (
                                                    <p className="text-center">No Products</p>
                                                )}
                                            </div>
                                        ))}
                                    </Form>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            ) : (
                <p className="text-center mt-4">No NRT Order History Available</p>
            )}

        </>
    );
};

export default MedicalQuestionnaire;
